export const PENDING = 'pending';
export const ACCOUNTING = 'accounting';
export const WAITING_FOR_CANCELLED = 'waiting_for_cancelled';
export const WAITING_FOR_ACCOUNTING_CANCELLED = 'waiting_for_accounting_cancelled';
export const COMPLETED = 'completed';
export const REJECTED = 'rejected';
export const CANCELLED = 'cancelled';



// WEBPACK FOOTER //
// ./src/constants/travelExpenseStatus.js